import { LeafMark } from './LeafMark';

/**
 * "HyperMaple" wordmark + the maple-leaf mark (docs/DESIGN.md: "the leaf is THE motif — it may
 * appear in empty states and the favicon, and nowhere else"). The leaf itself (`LeafMark`) is a
 * single original `<path>`: five asymmetric lobes (one top, two upper-side, two lower-side, like a
 * real maple leaf rather than a symmetric star) joined by concave quadratic curves, plus a short
 * tapered stem as a second sub-path within the same `d`. No traced or borrowed artwork. The brand
 * mark is the one place the leaf carries the accent glow instead of the neutral empty-state tint.
 */
export function BrandMark({ iconOnly = false }: { iconOnly?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2.5 font-display text-[0.95rem] font-semibold tracking-tight text-text">
      <span className="inline-flex text-accent" style={{ filter: 'drop-shadow(0 0 6px var(--accent-dim))' }}>
        <LeafMark size={22} />
      </span>
      {!iconOnly && 'HyperMaple'}
    </span>
  );
}
